import React from "react";

const BusinessSecurity = () => {
  return (
    <div className="pl-[1.8rem] pt-10">
      <div className="mb-[2rem]">
        <p className="text-[20px] font-[400] mb-[1rem]">Security</p>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Two factor authentication for login.
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            Require two factor authentication everytime <br /> you login.{" "}
          </div>
          <input type="radio" name="twoFactor" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Two factor authentication for transfer
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            Get an OTP via SMS & Email everytime a <br /> transfer is initiated{" "}
          </div>
          <input type="radio" name="Sms" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
      </div>

      <div>
        <p className="text-[20px] font-[400] mb-[1rem]">
          Transactions preferences
        </p>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Enable Transfers would only be processed via API only.{" "}
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            Transfers would be processed on via API.{" "}
          </div>
          <input type="radio" name="APIprocess" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Enable Transfers would only be processed via API only.
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            Transfers would be processed on via API.{" "}
          </div>
          <input type="radio" name="Apiprocess" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Enable Transfers would only be processed via API and Dashboard.
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            Transfers would be processed from both API's
            <br /> and dashboard.{" "}
          </div>
          <input type="radio" name="apianddash" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
        <label
          className="container"
          style={{ fontSize: "14px", fontWeight: 400 }}
        >
          <div className="text-[14px] font-[600] text-[#444444]">
            Disable all transfers.{" "}
          </div>
          <div className="text-[14px] font-[300] text-[#444444]">
            Transfers would be disabled from both API's
            <br /> and dashboard.{" "}
          </div>
          <input type="radio" name="disableapi" />
          <span className="checkmark" style={{ marginTop: "10px" }}></span>
        </label>
      </div>
      <section className="">
        <div className="flex pt-10 mt-10">
          <button className="w-[272px] h-[42px] rounded-[8px] text-white bg-primary">
            Update
          </button>
        </div>
      </section>
    </div>
  );
};

export default BusinessSecurity;
